import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import {
    MasterData,
    OutdatedHorizon,
    UpdateOutdatedHorizonPayload,
} from '../models/masterdata';

export interface DeletedOutdatedHorizon {
    provider: string;
}

@Injectable({
    providedIn: 'root',
})
export class MasterdataService {
    constructor(
        private http: HttpClient,
        public router: Router,
        public dialog: MatDialog,
    ) {}

    /**
     * Retrieve master data, including outdated horizon configurations.
     *
     * @return Application master data.
     */
    public getMasterdata(): Observable<MasterData> {
        return this.http.get<MasterData>(
            `${environment.API_ENDPOINT}/master-data`,
        );
    }

    /**
     * Create or update an outdated horizon configuration.
     *
     * @param payload Outdated horizon configuration.
     * @return Saved outdated horizon configuration.
     */
    public updateOutdatedHorizon(
        payload: UpdateOutdatedHorizonPayload,
    ): Observable<OutdatedHorizon> {
        return this.http.put<OutdatedHorizon>(
            `${environment.API_ENDPOINT}/master-data/outdated-horizons`,
            payload,
        );
    }

    /**
     * Delete the explicit outdated horizon configuration
     * for a provider.
     *
     * @param provider Provider whose configuration will be deleted.
     * @return Deleted provider information.
     */
    public deleteOutdatedHorizon(
        provider: string,
    ): Observable<DeletedOutdatedHorizon> {
        return this.http.delete<DeletedOutdatedHorizon>(
            `${environment.API_ENDPOINT}` +
                `/master-data/outdated-horizons/` +
                encodeURIComponent(provider),
        );
    }
}